import type { AccountNoteAttachment } from './types';

// Made-up notes and attachments so the list can be reviewed before svc-contracting serves them. Delete with the API
// wiring.
export const SAMPLE_NOTES_ATTACHMENTS: ReadonlyArray<AccountNoteAttachment> = [
  {
    id: 'sample-note-1',
    title: 'Partner portal login details',
    type: 'Note',
    lastModifiedDate: '2026-09-30T03:45:00.000Z',
  },
  {
    id: 'sample-note-2',
    title: 'Marketing Agreement signed',
    type: 'PDF',
    lastModifiedDate: '2026-08-14T04:54:00.000Z',
  },
  {
    id: 'sample-note-3',
    title: 'Rack Rates and Reservations details',
    type: 'Word',
    lastModifiedDate: '2026-07-02T08:58:00.000Z',
  },
  {
    id: 'sample-note-4',
    title: 'Bank details',
    type: 'PDF',
    lastModifiedDate: '2026-05-21T10:22:00.000Z',
  },
  {
    id: 'sample-note-5',
    title: 'Room type rate sheet',
    type: 'Excel',
    lastModifiedDate: '2026-03-11T01:39:00.000Z',
  },
  {
    id: 'sample-note-6',
    title: 'Alternative contacts',
    type: 'Note',
    lastModifiedDate: '2025-12-03T01:59:00.000Z',
  },
  {
    id: 'sample-note-7',
    title: 'Hotel logo',
    type: 'PNG',
    lastModifiedDate: '2025-10-28T21:49:00.000Z',
  },
];
